import React from "react";

export type ColumnButtonProps = {
  name: string;
  action: () => void;
};

const ColumnButton: React.FC<ColumnButtonProps> = ({ name, action }) => {
  return (
    <>
      <td className="whitespace-nowrap px-3 py-5 text-sm text-gray-500">
        <a
          onClick={() => action?.()}
          className="text-primary-600 hover:text-primary-900 cursor-pointer"
        >
          {name}
          <span className="sr-only">, {name}</span>
        </a>
      </td>
    </>
  );
};

export default ColumnButton;
